import { PinMark } from "@/components/Brand";

// Minimalist map UI drawn with SVG — route line + GPS pin drops. No stock imagery.
export function MapCanvas({ className = "", showPins = true }) {
  return (
    <div className={`relative w-full h-full overflow-hidden ${className}`} style={{ background: "#20211F" }}>
      {/* faint blocks = city grid */}
      <svg viewBox="0 0 340 620" className="absolute inset-0 w-full h-full" preserveAspectRatio="xMidYMid slice">
        <defs>
          <linearGradient id="mapfade" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="#262825" />
            <stop offset="1" stopColor="#1C1D1B" />
          </linearGradient>
        </defs>
        <rect width="340" height="620" fill="url(#mapfade)" />
        {/* road grid */}
        <g stroke="#33352F" strokeWidth="14" strokeLinecap="round">
          <line x1="-20" y1="120" x2="360" y2="150" />
          <line x1="-20" y1="330" x2="360" y2="300" />
          <line x1="-20" y1="500" x2="360" y2="520" />
          <line x1="70" y1="-20" x2="90" y2="640" />
          <line x1="230" y1="-20" x2="250" y2="640" />
        </g>
        <g stroke="#2C2E29" strokeWidth="5">
          <line x1="150" y1="-20" x2="160" y2="640" />
          <line x1="-20" y1="230" x2="360" y2="210" />
          <line x1="-20" y1="420" x2="360" y2="440" />
        </g>
        {/* the driven route */}
        <path
          d="M60 580 C60 500 120 470 150 420 C185 360 120 300 150 250 C180 205 250 200 250 150 C250 110 210 90 210 60"
          fill="none"
          stroke="#2BBFB3"
          strokeWidth="6"
          strokeLinecap="round"
          className="route-dash"
        />
        <path
          d="M60 580 C60 500 120 470 150 420 C185 360 120 300 150 250 C180 205 250 200 250 150 C250 110 210 90 210 60"
          fill="none"
          stroke="#2BBFB3"
          strokeOpacity="0.18"
          strokeWidth="16"
          strokeLinecap="round"
        />
      </svg>

      {showPins && (
        <>
          <FloatingPin left="42%" top="66%" delay="0s" />
          <FloatingPin left="45%" top="40%" delay="0.25s" tick="#F5A623" />
          <FloatingPin left="72%" top="23%" delay="0.5s" />
          {/* current position */}
          <div className="absolute" style={{ left: "60%", top: "10%" }}>
            <span className="absolute -inset-2 rounded-full bg-[#2BBFB3]/40 pulse-ring" />
            <span className="block w-3.5 h-3.5 rounded-full bg-[#2BBFB3] ring-4 ring-[#2BBFB3]/25" />
          </div>
        </>
      )}
    </div>
  );
}

function FloatingPin({ left, top, delay, tick = "#2BBFB3" }) {
  return (
    <div className="absolute pin-drop" style={{ left, top, animationDelay: delay, transform: "translate(-50%,-100%)" }}>
      <div className="drop-shadow-[0_6px_10px_rgba(0,0,0,0.5)]">
        <PinMark size={30} bg="#FFFFFF" tick={tick} />
      </div>
    </div>
  );
}

// Phone frame wrapping the map + a lesson HUD.
export function PhoneMockup({ className = "" }) {
  return (
    <div className={`relative ${className}`}>
      <div className="relative rounded-[2.6rem] border-8 border-[#151614] bg-[#151614] shadow-2xl overflow-hidden w-[280px] h-[580px]">
        {/* notch */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 z-20 w-28 h-6 bg-[#151614] rounded-b-2xl" />
        <div className="relative w-full h-full rounded-[2rem] overflow-hidden">
          <MapCanvas />
          {/* top status */}
          <div className="absolute top-3 left-3 right-3 z-20 flex items-center justify-between">
            <span className="px-2.5 py-1 rounded-full bg-black/40 backdrop-blur text-[10px] text-white/80 font-medium tracking-wide">
              LESSON • REC
            </span>
            <span className="flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-[#2BBFB3] text-[10px] text-[#0f1211] font-semibold">
              <span className="w-1.5 h-1.5 rounded-full bg-[#0f1211] animate-pulse" /> 47:12
            </span>
          </div>
          {/* bottom HUD card */}
          <div className="absolute bottom-3 left-3 right-3 z-20 rounded-2xl bg-white/95 backdrop-blur p-3.5">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-[10px] uppercase tracking-widest text-[#2B2B2B]/50 font-semibold">Identified error</p>
                <p className="text-sm font-semibold text-[#2B2B2B] font-display">Failed to give way</p>
              </div>
              <span className="text-[10px] font-semibold text-white bg-[#F5A623] px-2 py-1 rounded-md">Pin #3</span>
            </div>
            <div className="mt-3 grid grid-cols-4 gap-1.5">
              {["Speed", "Signal", "Gap", "Mirror"].map((t) => (
                <div key={t} className="rounded-lg bg-[#2B2B2B]/5 py-1.5 text-center text-[9px] font-medium text-[#2B2B2B]/70">
                  {t}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
